var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdouinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5255",
    "data-name": "Group 5255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.118,
    height: 180.249,
    viewBox: "0 0 200.118 180.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 200.118,
    height: 180.249,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5256",
    "data-name": "Group 5256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5255-2",
    "data-name": "Group 5255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8926",
    "data-name": "Path 8926",
    d: "M26.838,298.1c4.635-1.935,11.575-5.078,11.575-14.348,0-9.753-9.2-14.912-21.56-14.912H.713c-.476,0-.713.242-.713.484s.594.483.832.725L4.4,272.385a2.422,2.422,0,0,1,1.07,2.257l1.283,48.847a2.423,2.423,0,0,1-1.07,2.257l-3.565,2.337c-.238.323-.832.484-.832.726s.237.484.713.484H20.657c9.747,0,17.994-5.562,17.994-17.25,0-8.947-7.178-12.333-11.813-13.945m-7.251,27.164H15.9V300.6h1.783c5.824,0,8.32,2.982,8.32,10.882,0,10.882-1.188,13.784-6.419,13.784m-1.9-28.7H15.9v-23.7h1.783c5.824,0,8.32,2.66,8.32,10.882,0,9.673-2.5,12.816-8.32,12.816",
    transform: "translate(0 -149.08)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5258",
    "data-name": "Group 5258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5257",
    "data-name": "Group 5257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M190.161,303.76c-7.593.462-13.72,5.439-12.755,21.288,1.21,19.873,7.886,23.908,15.48,23.446,7.711-.47,13.849-5.285,12.639-25.158-.965-15.85-7.651-20.045-15.363-19.576m2.514,41.274c-3.085.188-4.913-2.447-6.015-20.549-.853-14,.627-17.077,3.712-17.265,3.2-.2,5.046,2.681,5.9,16.68,1.1,18.1-.392,20.939-3.6,21.134m50.983,2.718-3.685-2.821a1.263,1.263,0,0,1-.118-.726v-39.9c0-.322-.119-.483-.595-.483H227.849c-.357,0-.713.081-.713.322,0,.161.238.4.594.645l3.447,2.257a.685.685,0,0,1,.357.645v31.033c0,3.949-2.5,6.449-5.349,6.449-3.09,0-4.635-1.612-4.635-4.675V306.871c0-.323-.238-.483-.594-.483H209.544c-.356,0-.713.081-.713.322,0,.161.238.4.476.645l3.566,2.257a.685.685,0,0,1,.356.645v30.16c0,5.481,3.209,8.221,10.1,8.221a11.622,11.622,0,0,0,7.964-3.063h.238v2.741c0,.161.356.322.832.322h11.054c.476,0,.832-.081.832-.322,0-.161-.237-.4-.594-.564m18.44,0-3.685-2.821c-.238-.161-.238-.4-.238-.726v-39.9c0-.322-.237-.483-.594-.483l-13.228.107c-.357,0-.713.081-.713.322,0,.161.237.4.475.645l3.566,2.257a.685.685,0,0,1,.356.645l1.818,36.407c0,.323,0,.564-.237.726l-3.685,2.821c-.238.161-.475.4-.475.564,0,.241.356.322.713.322h15.69c.475,0,.713-.081.713-.322,0-.161-.238-.4-.475-.564m35.868,0-3.685-2.821c-.237-.161-.237-.4-.237-.726l.748-32.162c0-5.4-3.923-8.221-9.866-8.221a12.376,12.376,0,0,0-8.2,2.821h-.238v-2.338c0-.322-.119-.483-.594-.483H264.48c-.356,0-.713.081-.713.322,0,.161.237.4.475.645l3.566,2.257a.685.685,0,0,1,.356.645V344.2c0,.323,0,.564-.237.726l-3.685,2.821c-.357.161-.475.4-.475.564,0,.241.237.322.713.322h15.69c.356,0,.713-.081.713-.322,0-.161-.238-.4-.594-.564l-3.685-2.821a1.259,1.259,0,0,1-.119-.726V314.3c0-4.353,3.091-7.013,5.943-7.013,2.734,0,4.041,1.612,4.041,4.675l-.748,32.242c0,.323,0,.564-.238.726l-3.685,2.821c-.237.161-.475.4-.475.564,0,.241.238.322.713.322h15.69c.357,0,.713-.081.713-.322,0-.161-.237-.4-.475-.564",
    transform: "translate(-98.322 -168.427)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5259",
    "data-name": "Group 5259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M336.652,266.331a6.254,6.254,0,1,0,6.254,6.254,6.254,6.254,0,0,0-6.254-6.254",
    transform: "translate(-183.218 -147.69)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5262",
    "data-name": "Group 5262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5261",
    "data-name": "Group 5261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8929",
    "data-name": "Path 8929",
    d: "M104.855,269.171H87.561c-.475,0-.723.241-.734.483s.573.483.8.724l3.465,2.333a2.313,2.313,0,0,1,.972,2.253l.351,48.757a2.531,2.531,0,0,1-1.167,2.253l-3.667,2.333c-.252.322-.853.482-.863.724s.217.483.692.483h14.834c12.005,0,19.373-5.471,20.507-31.7.9-20.838-5.893-28.643-17.9-28.643m8.152,28.643c-1.064,24.62-5.595,27.677-10.23,27.677h-2.14l2.261-52.3h2.14c4.636,0,8.9,3.057,7.969,24.62",
    transform: "translate(-48.089 -149.265)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M197.08,46.354c-1.017-9.241-8.034-17.291-19.351-19.537-3.517-13.034-18.66-22.88-36.808-22.806-21.08.086-32.494,8.254-36.2,19.62a21.944,21.944,0,0,0-6.592,7.416c-17.19,1.079-30.7,12.132-30.7,25.618a20.069,20.069,0,0,0,.649,5.048C65.5,63.606,64,65.9,64,68.371c0,6.495,10.363,11.76,23.146,11.76h.064a42.011,42.011,0,0,0,13.674,2.246,43.3,43.3,0,0,0,7.319-.624c6.966,3.575,16.236,5.756,26.412,5.756a61.208,61.208,0,0,0,23.536-4.415c.632.02,1.269.031,1.909.031a54.369,54.369,0,0,0,18.524-3.108,30.8,30.8,0,0,0,9.594,1.5c13.315,0,24.108-8.161,24.108-18.228,0-7.688-6.3-14.26-15.2-16.939",
    transform: "translate(-35.489 -2.224)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M195.43,43.7c-2.245-17.854-14.273-20.367-19.137-20.527C151.062-16.281,110.757,6.6,110.757,6.6c-4.918,3.528-2.031,3.314,2.365,1.444C147.941-4.9,168.543,19.006,172.444,23.383c-4.49.214-12.134,5.613-10.727,6.942,21.589-13.562,29.867,7.966,29.864,12.943-3.207,0-7.8,1.229-8.66,3.314,14.219-4.811,29.614,5.239,22.344,21.275s-31.325,9.836-35.174,5.239c-.8-.428-2.352-.428,1.176,3.421-6.522,2.566-13.15,2.245-17,2.138-29.4,10.157-43.941,1.711-49.286-.748C93.758,80.473,83.6,76.945,80.715,76.09c1.5-.641,4.063-2.352,3.849-4.276-3.742,3.956-9.836,3.207-12.295,2.78-18.709-3.314-9.729-13.15-7.163-15.716C63.074,28.3,93.865,30.011,99.531,30.546c-3.1-2.138-1.6-1.069-5.025-2.673,5.71-8.1,15.752-9.441,16.329-9.512a25.9,25.9,0,0,1,.563-2.569C97.927,19.213,93.116,25.093,90.9,27.4,55.649,29.329,61,53.983,62.112,58.77,45.733,74.218,69.748,79.613,79.859,78.335c5.559,2.78,19.672,3.314,24.152,2.631,24.889,14.368,48.289,2.577,51.327.9,8.757,2.048,21.433-2.261,20.955-2.566,0,0,26.835,6.949,34.319-10.263S201.1,44.337,195.43,43.7M110.864,18.358l-.028,0c0,.072.028,0,.028,0",
    transform: "translate(-31.358 0)",
    fill: "#0f0e0b",
    fillRule: "evenodd"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5268",
    "data-name": "Group 5268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5267",
    "data-name": "Group 5267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M151.722,191.721a4.023,4.023,0,0,0-5.2,2.309l-8.1,21.029a4.023,4.023,0,1,0,7.509,2.892l8.1-21.029a4.024,4.024,0,0,0-2.309-5.2",
    transform: "translate(-76.613 -106.167)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5270",
    "data-name": "Group 5270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5269",
    "data-name": "Group 5269",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M234.889,221.222c-2.074-.8-4.937.128-5.735,2.2l-8.1,21.029c-.8,2.074.77,4.509,2.843,5.308a4.023,4.023,0,0,0,5.2-2.309l8.1-21.029a4.024,4.024,0,0,0-2.309-5.2",
    transform: "translate(-122.467 -122.518)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5272",
    "data-name": "Group 5272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5271",
    "data-name": "Group 5271",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M297.261,188.758a2.768,2.768,0,0,0-3.582,1.6L288.1,204.889a2.773,2.773,0,1,0,5.172,2l5.576-14.535a2.785,2.785,0,0,0-1.59-3.595",
    transform: "translate(-159.661 -104.57)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5274",
    "data-name": "Group 5274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M328.941,208.678a2.768,2.768,0,0,0-3.581,1.6l-5.576,14.535a2.772,2.772,0,1,0,5.172,2l5.576-14.535a2.785,2.785,0,0,0-1.59-3.595",
    transform: "translate(-177.228 -115.616)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5276",
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M104.452,191.861a2.532,2.532,0,0,0-3.272,1.452l-5.093,13.221a2.531,2.531,0,0,0,4.725,1.818l5.093-13.221a2.529,2.529,0,0,0-1.453-3.27",
    transform: "translate(-53.19 -106.3)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdouinLogo);
export default __webpack_public_path__ + "static/media/bdouin-logo.358668ec27f650dbb5c003b7e7119819.svg";
export { ForwardRef as ReactComponent };